var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "table",
      staticClass: "c-table",
      class: {
        "c-table_scrolled": _vm.isScrolled,
        "c-table_scrolled__last-fixed":
          _vm.isScrolled && _vm.fixedColumn === "last",
        "c-table_scrolled__first-fixed":
          _vm.isScrolled && _vm.fixedColumn === "first",
        "c-table_scroll_end": _vm.isScrollEnd,
        "c-table_scroll": _vm.isScroll,
      },
    },
    [
      _c("m-column-filters", {
        ref: "columnFilters",
        attrs: {
          column: _vm.filteredColumn,
          "reference-list": _vm.referenceList,
          "active-filters": _vm.activeFilteredColumns,
        },
        on: {
          getReferenceValues: _vm.getReferenceValues,
          close: function ($event) {
            _vm.filteredColumn = null
          },
          setFilter: _vm.setColumnFilter,
          removeFilter: _vm.removeColumnFilter,
        },
      }),
      _vm.data.records.length !== 0 && _vm.fixedColumn === "last"
        ? _c("div", {
            class: {
              "c-table__shadow": _vm.data.actions,
              "c-table__shadow_active": _vm.data.actions,
              // 'c-table__empty__shadow': data.records.length === 0
            },
          })
        : _vm._e(),
      _vm.isScroll
        ? _c("div", { staticClass: "c-table__scrollbar-wrapper" })
        : _vm._e(),
      _c(
        "perfect-scrollbar",
        {
          ref: "wrapper",
          staticClass: "c-table__wrapper",
          on: { scroll: _vm.scroll },
        },
        [
          _c("table", { ref: "container", staticClass: "c-table__container" }, [
            _c(
              "thead",
              { ref: "header", staticClass: "c-table__header" },
              _vm._l(_vm.levels, function (i) {
                return _c(
                  "tr",
                  { key: i, staticClass: "c-table__header-row" },
                  [
                    _vm._l(
                      _vm.getTableColumns(i),
                      function (column, columnIndex) {
                        return _c(
                          "th",
                          {
                            key: column.id,
                            staticClass: "c-table__column",
                            class: {
                              "c-table__column_with_filter": column.type,
                              "c-table__column_hidden": _vm.isDisabled(
                                column.id
                              ),
                              "c-table__column_sorted": _vm.isSorted(column),
                              "sticky-column sticky-column__first":
                                _vm.fixedColumn === "first" &&
                                columnIndex === 0,
                              "sticky-column__first-shadow-active":
                                _vm.fixedColumn === "first" &&
                                columnIndex === 0 &&
                                _vm.isScrolled,
                            },
                            attrs: {
                              id: `c-table-column-${column.id}`,
                              colspan: _vm.getColspan(column),
                              rowspan: _vm.getRowspan(column),
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "c-table__column-wrapper" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "c-table__column-label",
                                    class: {
                                      "c-table__column-label-children":
                                        !_vm.isCategory(column) &&
                                        _vm.sortedColumn,
                                      "c-table__column-no-sort":
                                        _vm.isColumnNoSort(column),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setSortedColumn(
                                          column,
                                          _vm.sortedColumn
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(column.label) + " ")]
                                ),
                                column.description || column.type
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "c-table__column-actions",
                                      },
                                      [
                                        column.fullName
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__column-action c-table__column-action_description",
                                              },
                                              [
                                                _c("c-button", {
                                                  attrs: {
                                                    id: `table-column-button-description-${column.id}`,
                                                    size: "small",
                                                    icon: "info",
                                                    "no-border": "",
                                                  },
                                                }),
                                                _c(
                                                  "b-popover",
                                                  {
                                                    attrs: {
                                                      placement: "top",
                                                      triggers: "hover",
                                                      target: `table-column-button-description-${column.id}`,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          column.fullName
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.isColumnFiltered(column.id)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__column-action",
                                              },
                                              [
                                                _c("c-button", {
                                                  attrs: {
                                                    id: `table-column-button-filter-${column.id}`,
                                                    size: "small",
                                                    "no-border": "",
                                                    active:
                                                      _vm.isColumnActiveFiltered(
                                                        column.id
                                                      ),
                                                    icon: {
                                                      icon: "filter-column",
                                                      activeColor: "blue",
                                                    },
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openColumnFilterModal(
                                                        column
                                                      )
                                                    },
                                                  },
                                                }),
                                                _c(
                                                  "b-popover",
                                                  {
                                                    attrs: {
                                                      placement: "top",
                                                      triggers: "hover",
                                                      target: `table-column-button-filter-${column.id}`,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.isColumnActiveFiltered(
                                                            column.id
                                                          )
                                                            ? "Изменить фильтр"
                                                            : "Применить фильтр"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      }
                    ),
                    _vm.data.actions && i === 1
                      ? _c(
                          "th",
                          {
                            staticClass:
                              "c-table__column c-table__column_actions",
                            class: {
                              "sticky-column sticky-column__last":
                                _vm.fixedColumn === "last",
                            },
                            attrs: { rowspan: _vm.levels },
                          },
                          [_c("div", { staticClass: "c-table__column-empty" })]
                        )
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
            _c(
              "tbody",
              { staticClass: "c-table__records" },
              [
                _vm.summaryRecord
                  ? _c(
                      "tr",
                      { staticClass: "summary_record" },
                      [
                        _vm._l(
                          _vm.getTableColumns(_vm.levels, true),
                          function (column, columnIndex) {
                            return _c(
                              "td",
                              {
                                class: {
                                  "c-table__cell":
                                    column.id === "added_amount" ||
                                    column.id === "withdraw_amount",
                                },
                              },
                              [
                                column.id === "added_amount"
                                  ? _c(
                                      "div",
                                      { staticClass: "c-table__cell-value" },
                                      [
                                        _c(
                                          "span",
                                          { staticStyle: { color: "#12C971" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.data.summaryAddedAmount
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                column.id === "withdraw_amount"
                                  ? _c(
                                      "div",
                                      { staticClass: "c-table__cell-value" },
                                      [
                                        _c(
                                          "span",
                                          { staticStyle: { color: "#FF238D" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.data.summaryWithdrawAmount
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }
                        ),
                        _vm.data.actions
                          ? _c("td", {
                              staticClass: "c-table__cell_actions",
                              class: {
                                "sticky-column sticky-column__last":
                                  _vm.fixedColumn === "last",
                              },
                            })
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._l(_vm.data.records, function (record, recordIndex) {
                  return _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: record.isShowRow,
                          expression: "record.isShowRow",
                        },
                      ],
                      key: recordIndex,
                      staticClass: "c-table__record",
                      class: {
                        "c-table__summary-record":
                          record.id === "summary_record",
                        "c-table__red": _vm.shouldRowBeRed(record),
                        "c-table__blue": _vm.shouldRowBeBlue(record),
                        "c-table__edited": _vm.shouldRowBeEdited(record),
                      },
                      attrs: { id: `row-${record.id.value}` },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("handleEditItemClick", record)
                        },
                      },
                    },
                    [
                      _vm._l(
                        _vm.getTableColumns(_vm.levels, true),
                        function (column, columnIndex) {
                          return _c(
                            "td",
                            {
                              key: column.id,
                              staticClass: "c-table__cell",
                              class: {
                                "c-table__cell_string":
                                  column.type === "string",
                                "c-table__cell_reference":
                                  column.type === "reference",
                                "c-table__cell_number":
                                  column.type === "number",
                                "c-table__cell_date": column.type === "date",
                                "c-table__cell_hidden": _vm.isDisabled(
                                  column.id
                                ),
                                "sticky-column sticky-column__first":
                                  _vm.fixedColumn === "first" &&
                                  columnIndex === 0,
                                "sticky-column__first-shadow-active":
                                  _vm.fixedColumn === "first" &&
                                  columnIndex === 0 &&
                                  _vm.isScrolled,
                                ["c-table__cell_" + column.id]: column.id,
                                [`c-table__cell__data__${_vm.data.type}`]:
                                  _vm.data.type,
                              },
                              attrs: {
                                "data-cell":
                                  record[column.id] && record[column.id].class,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleClick(record, column)
                                },
                              },
                            },
                            [
                              _vm.isDefaultCell(record, column)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "c-table__cell-value",
                                      class: {
                                        "c-table__cell-pre-formatted":
                                          column.id ===
                                            "postCategorySpecialty" &&
                                          !_vm.isCandidatesTableType,
                                        "w-250": column.id === "address",
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(record[column.id].value)),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isCustomCellDataType &&
                              !_vm.isDefaultCell(record, column)
                                ? _c("c-table-cell", {
                                    staticClass: "c-table__cell-cell",
                                    attrs: {
                                      cell: _vm.getCustomCellId(
                                        record[column.id]
                                      ),
                                      data: record[column.id],
                                    },
                                  })
                                : _vm._e(),
                              record[column.id] && record[column.id].employee
                                ? _c("c-table-cell", {
                                    staticClass: "c-table__cell-cell",
                                    attrs: {
                                      cell: "employee",
                                      data: record[column.id].employee,
                                    },
                                  })
                                : _vm._e(),
                              record[column.id] &&
                              record[column.id].depositState
                                ? _c("c-table-cell", {
                                    staticClass: "c-table__cell-cell",
                                    attrs: {
                                      cell: "deposit-state",
                                      data: record[column.id].depositState,
                                    },
                                  })
                                : _vm._e(),
                              column.id === "worker" ||
                              column.id === "worker_author" ||
                              column.id === "author" ||
                              column.id === "author_update" ||
                              column.id === "author_create" ||
                              column.id === "delete_author"
                                ? _c(
                                    "div",
                                    { staticClass: "c-table__cell-value" },
                                    [
                                      _c("worker-or-user", {
                                        attrs: { value: record[column.id] },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              column.id === "transaction_type"
                                ? _c(
                                    "div",
                                    { staticClass: "c-table__cell-value" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "b-popover",
                                              rawName: "v-b-popover.html",
                                              value: {
                                                container: "#app",
                                                trigger: "hover blur",
                                                content:
                                                  record.transaction_type_name
                                                    .value,
                                                placement: "top",
                                              },
                                              expression:
                                                "{ container: '#app', trigger: 'hover blur', content: record.transaction_type_name.value, placement: 'top' }",
                                              modifiers: { html: true },
                                            },
                                          ],
                                          style: record[column.id].style,
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(record[column.id].value) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              column.id === "added_amount" ||
                              column.id === "withdraw_amount"
                                ? _c(
                                    "div",
                                    { staticClass: "c-table__cell-value" },
                                    [
                                      _c(
                                        "span",
                                        { style: record[column.id].style },
                                        [
                                          _vm._v(
                                            _vm._s(record[column.id].value)
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              column.id === "amount"
                                ? _c(
                                    "div",
                                    { staticClass: "c-table__cell-value" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          style:
                                            String(record[column.id].value) !==
                                            "0"
                                              ? record[column.id].style
                                              : "",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(record[column.id].value)
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              column.id === "balance"
                                ? _c(
                                    "div",
                                    { staticClass: "c-table__cell-value" },
                                    [
                                      record.use_personal_account
                                        ? _c("svg-icon", {
                                            staticClass: "c-table__cell-icon",
                                            attrs: { name: "ls" },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        {
                                          style:
                                            String(record[column.id].value) !==
                                            "0"
                                              ? record[column.id].style
                                              : "",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(record[column.id].value)
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              column.id === "status"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "c-table__cell-value",
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "center",
                                      },
                                    },
                                    [
                                      _c("svg-icon", {
                                        directives: [
                                          {
                                            name: "b-popover",
                                            rawName:
                                              "v-b-popover.hover.blur.top",
                                            value: record[column.id].title,
                                            expression:
                                              "record[column.id].title",
                                            modifiers: {
                                              hover: true,
                                              blur: true,
                                              top: true,
                                            },
                                          },
                                        ],
                                        staticStyle: {
                                          width: "14px",
                                          height: "14px",
                                        },
                                        attrs: {
                                          name:
                                            "status-" + record[column.id].value,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              column.id === "executive"
                                ? _c(
                                    "div",
                                    { staticClass: "c-table__cell-value" },
                                    [
                                      record[column.id].workers.length &&
                                      record[column.id].workers.length < 3
                                        ? _vm._l(
                                            record[column.id].workers,
                                            function (worker) {
                                              return _c("worker-or-user", {
                                                key: worker.worker.id,
                                                attrs: { value: worker },
                                              })
                                            }
                                          )
                                        : record[column.id].workers.length &&
                                          record[column.id].workers.length >= 3
                                        ? [
                                            _c(
                                              "router-link",
                                              {
                                                staticStyle: {
                                                  "white-space": "nowrap",
                                                },
                                                attrs: {
                                                  target: "_blank",
                                                  to: {
                                                    name: "function-information",
                                                    query: {
                                                      id: record.id.value,
                                                    },
                                                    hash: "#performers",
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      record[column.id].workers
                                                        .length +
                                                        " " +
                                                        _vm.declOfNum(
                                                          record[column.id]
                                                            .workers.length,
                                                          [
                                                            "сотрудник",
                                                            "сотрудника",
                                                            "сотрудников",
                                                          ]
                                                        )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : record[column.id].posts.length
                                        ? _vm._l(
                                            record[column.id].posts,
                                            function (post) {
                                              return _c("div", [
                                                _vm._v(
                                                  _vm._s(post.post.name) +
                                                    " / " +
                                                    _vm._s(
                                                      post.ranks.length
                                                        ? post.ranks
                                                            .map(
                                                              (rank) =>
                                                                rank.name
                                                            )
                                                            .join(", ")
                                                        : "-"
                                                    ) +
                                                    " / " +
                                                    _vm._s(
                                                      post.specialities.length
                                                        ? post.specialities
                                                            .map(
                                                              (speciality) =>
                                                                speciality.name
                                                            )
                                                            .join(", ")
                                                        : "-"
                                                    )
                                                ),
                                              ])
                                            }
                                          )
                                        : record[column.id].typePosts.length
                                        ? _vm._l(
                                            record[column.id].typePosts,
                                            function (typePost) {
                                              return _c("div", [
                                                _vm._v(_vm._s(typePost.name)),
                                              ])
                                            }
                                          )
                                        : [_vm._v("Все")],
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              column.id === "filials"
                                ? _c(
                                    "div",
                                    { staticClass: "c-table__cell-value" },
                                    [
                                      _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            record[column.id].value
                                          ),
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              column.id === "responsible"
                                ? _c(
                                    "div",
                                    { staticClass: "c-table__cell-value" },
                                    [
                                      record[column.id].value.length
                                        ? _vm._l(
                                            record[column.id].value,
                                            function (worker) {
                                              return _c("worker-or-user", {
                                                key: worker.worker.id,
                                                attrs: { value: worker },
                                              })
                                            }
                                          )
                                        : [_vm._v("-")],
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              column.id === "labor_costs"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "c-table__cell-value",
                                      staticStyle: { "text-align": "right" },
                                    },
                                    [
                                      record[column.id].value
                                        ? _c("div", [
                                            _vm._v(
                                              _vm._s(record[column.id].value) +
                                                " ч"
                                            ),
                                          ])
                                        : _vm._e(),
                                      record[column.id].repeat_interval
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                color: "#8E9CBB",
                                                "white-space": "nowrap",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    record[column.id]
                                                      .repeat_interval
                                                  ) +
                                                  " ฿/" +
                                                  _vm._s(
                                                    _vm.repeatTypes[
                                                      record[column.id]
                                                        .repeat_type
                                                    ]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              column.id === "indicators"
                                ? _c(
                                    "div",
                                    { staticClass: "c-table__cell-value" },
                                    [
                                      record[column.id].value
                                        ? _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                target: "_blank",
                                                to: {
                                                  name: "function-indicators",
                                                  query: {
                                                    id: record.id.value,
                                                  },
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    record[column.id].value
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        }
                      ),
                      _vm.data.actions
                        ? _c(
                            "td",
                            {
                              staticClass:
                                "c-table__cell c-table__cell_actions",
                              class: {
                                "sticky-column sticky-column__last":
                                  _vm.fixedColumn === "last",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "c-table__cell-actions",
                                  class: {
                                    [`c-table__cell__data__${_vm.data.type}`]:
                                      _vm.data.type,
                                  },
                                },
                                [
                                  _vm.data.type === "finance" &&
                                  _vm.data.subtype !== "accountable"
                                    ? _c(
                                        "div",
                                        { staticClass: "finance-actions" },
                                        [
                                          record
                                            ? [
                                                record
                                                  ? _c("c-button-2", {
                                                      directives: [
                                                        {
                                                          name: "b-popover",
                                                          rawName:
                                                            "v-b-popover.html",
                                                          value: {
                                                            container: "#app",
                                                            trigger: "hover",
                                                            content:
                                                              "Редактировать",
                                                            placement: "bottom",
                                                          },
                                                          expression:
                                                            "{\n                      container: '#app',\n                      trigger: 'hover',\n                      content: 'Редактировать',\n                      placement: 'bottom',\n                    }",
                                                          modifiers: {
                                                            html: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "finance-actions__edit",
                                                      attrs: {
                                                        icon: "edit",
                                                        size: "iconic",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "editRecord",
                                                            record
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                                record.calculation &&
                                                _vm.operationsStatus ===
                                                  "active"
                                                  ? _c(
                                                      "router-link",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "b-popover",
                                                            rawName:
                                                              "v-b-popover.html",
                                                            value: {
                                                              container: "#app",
                                                              trigger:
                                                                "hover blur",
                                                              content:
                                                                "Сохраненный расчет по филиалу " +
                                                                record
                                                                  .calculation
                                                                  .filial +
                                                                " за " +
                                                                record
                                                                  .date_created
                                                                  .value,
                                                              placement: "top",
                                                            },
                                                            expression:
                                                              "{\n                      container: '#app',\n                      trigger: 'hover blur',\n                      content: 'Сохраненный расчет по филиалу ' + record.calculation.filial + ' за ' + record.date_created.value,\n                      placement: 'top',\n                    }",
                                                            modifiers: {
                                                              html: true,
                                                            },
                                                          },
                                                        ],
                                                        attrs: {
                                                          target: "_blank",
                                                          to: {
                                                            name: "save-calculation-production",
                                                            query: {
                                                              calc_id:
                                                                record
                                                                  .calculation
                                                                  .id,
                                                            },
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("svg-icon", {
                                                          attrs: {
                                                            size: 16,
                                                            name: "calculator",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                !record.calculation &&
                                                _vm.operationsStatus ===
                                                  "active"
                                                  ? _c("c-button-2", {
                                                      directives: [
                                                        {
                                                          name: "b-popover",
                                                          rawName:
                                                            "v-b-popover.html",
                                                          value: {
                                                            container: "#app",
                                                            trigger:
                                                              "hover blur",
                                                            boundary: "window",
                                                            content:
                                                              "Удалить операцию",
                                                            placement: "top",
                                                          },
                                                          expression:
                                                            "{\n                      container: '#app',\n                      trigger: 'hover blur',\n                      boundary: 'window',\n                      content: 'Удалить операцию',\n                      placement: 'top',\n                    }",
                                                          modifiers: {
                                                            html: true,
                                                          },
                                                        },
                                                      ],
                                                      attrs: {
                                                        size: "iconic",
                                                        icon: {
                                                          icon: "trash",
                                                          color: "secondary",
                                                        },
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "remove",
                                                            record
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm.operationsStatus ===
                                                "removed"
                                                  ? _c("c-button-2", {
                                                      directives: [
                                                        {
                                                          name: "b-popover",
                                                          rawName:
                                                            "v-b-popover.html",
                                                          value: {
                                                            container: "#app",
                                                            trigger:
                                                              "hover blur",
                                                            boundary: "window",
                                                            content:
                                                              "Восстановить операцию 12",
                                                            placement: "top",
                                                          },
                                                          expression:
                                                            "{\n                      container: '#app',\n                      trigger: 'hover blur',\n                      boundary: 'window',\n                      content: 'Восстановить операцию 12',\n                      placement: 'top',\n                    }",
                                                          modifiers: {
                                                            html: true,
                                                          },
                                                        },
                                                      ],
                                                      attrs: {
                                                        size: "iconic",
                                                        icon: {
                                                          icon: "restore",
                                                        },
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "restore",
                                                            record
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm.data.type === "calculation-sheets"
                                    ? _c(
                                        "div",
                                        { staticClass: "finance-actions" },
                                        [
                                          record
                                            ? [
                                                record
                                                  ? _c(
                                                      "router-link",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "b-popover",
                                                            rawName:
                                                              "v-b-popover.html",
                                                            value: {
                                                              container: "#app",
                                                              trigger:
                                                                "hover blur",
                                                              content:
                                                                "Редактировать",
                                                              placement: "top",
                                                            },
                                                            expression:
                                                              "{\n                      container: '#app',\n                      trigger: 'hover blur',\n                      content: 'Редактировать',\n                      placement: 'top',\n                    }",
                                                            modifiers: {
                                                              html: true,
                                                            },
                                                          },
                                                        ],
                                                        staticClass:
                                                          "finance-actions__edit",
                                                        attrs: {
                                                          to: {
                                                            name: "calculation-sheet",
                                                            params: {
                                                              id: record.id.value.replace(
                                                                /[^0-9]/g,
                                                                ""
                                                              ),
                                                            },
                                                          },
                                                        },
                                                        nativeOn: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.$emit(
                                                              "handleEditItemClick",
                                                              record,
                                                              "edit"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("svg-icon", {
                                                          attrs: {
                                                            size: 16,
                                                            name: "pencil",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                record.calculation &&
                                                _vm.operationsStatus ===
                                                  "active"
                                                  ? _c(
                                                      "router-link",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "b-popover",
                                                            rawName:
                                                              "v-b-popover.html",
                                                            value: {
                                                              container: "#app",
                                                              trigger:
                                                                "hover blur",
                                                              content:
                                                                "Сохраненный расчет по филиалу " +
                                                                record
                                                                  .calculation
                                                                  .filial +
                                                                " за " +
                                                                record
                                                                  .date_created
                                                                  .value,
                                                              placement: "top",
                                                            },
                                                            expression:
                                                              "{\n                      container: '#app',\n                      trigger: 'hover blur',\n                      content: 'Сохраненный расчет по филиалу ' + record.calculation.filial + ' за ' + record.date_created.value,\n                      placement: 'top',\n                    }",
                                                            modifiers: {
                                                              html: true,
                                                            },
                                                          },
                                                        ],
                                                        attrs: {
                                                          target: "_blank",
                                                          to: {
                                                            name: "save-calculation-production",
                                                            query: {
                                                              calc_id:
                                                                record
                                                                  .calculation
                                                                  .id,
                                                            },
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("svg-icon", {
                                                          attrs: {
                                                            size: 16,
                                                            name: "calculator",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                !record.calculation &&
                                                _vm.operationsStatus ===
                                                  "active"
                                                  ? _c("c-button-2", {
                                                      directives: [
                                                        {
                                                          name: "b-popover",
                                                          rawName:
                                                            "v-b-popover.html",
                                                          value: {
                                                            container: "#app",
                                                            trigger:
                                                              "hover blur",
                                                            boundary: "window",
                                                            content:
                                                              "Удалить операцию",
                                                            placement: "top",
                                                          },
                                                          expression:
                                                            "{\n                      container: '#app',\n                      trigger: 'hover blur',\n                      boundary: 'window',\n                      content: 'Удалить операцию',\n                      placement: 'top',\n                    }",
                                                          modifiers: {
                                                            html: true,
                                                          },
                                                        },
                                                      ],
                                                      attrs: {
                                                        size: "iconic",
                                                        icon: {
                                                          icon: "trash",
                                                          color: "secondary",
                                                        },
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "remove",
                                                            record
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm.operationsStatus ===
                                                "removed"
                                                  ? _c("c-button-2", {
                                                      directives: [
                                                        {
                                                          name: "b-popover",
                                                          rawName:
                                                            "v-b-popover.html",
                                                          value: {
                                                            container: "#app",
                                                            trigger:
                                                              "hover blur",
                                                            boundary: "window",
                                                            content:
                                                              "Восстановить операцию",
                                                            placement: "top",
                                                          },
                                                          expression:
                                                            "{\n                      container: '#app',\n                      trigger: 'hover blur',\n                      boundary: 'window',\n                      content: 'Восстановить операцию',\n                      placement: 'top',\n                    }",
                                                          modifiers: {
                                                            html: true,
                                                          },
                                                        },
                                                      ],
                                                      attrs: {
                                                        size: "iconic",
                                                        icon: {
                                                          icon: "restore",
                                                        },
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "restore",
                                                            record
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm.data.type === "functions"
                                    ? _c(
                                        "div",
                                        { staticClass: "finance-actions" },
                                        [
                                          record
                                            ? _c(
                                                "router-link",
                                                {
                                                  directives: [
                                                    {
                                                      name: "b-popover",
                                                      rawName:
                                                        "v-b-popover.html",
                                                      value: {
                                                        container: "#app",
                                                        trigger: "hover blur",
                                                        content:
                                                          "Редактировать",
                                                        placement: "top",
                                                      },
                                                      expression:
                                                        "{\n                    container: '#app',\n                    trigger: 'hover blur',\n                    content: 'Редактировать',\n                    placement: 'top',\n                  }",
                                                      modifiers: { html: true },
                                                    },
                                                  ],
                                                  staticClass:
                                                    "finance-actions__edit",
                                                  attrs: {
                                                    to: {
                                                      name: "function-information",
                                                      query: {
                                                        id: record.id.value,
                                                      },
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("svg-icon", {
                                                    attrs: {
                                                      size: 16,
                                                      name: "pencil",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.data.type === "employees"
                                    ? _c("c-table-actions", {
                                        attrs: {
                                          type: _vm.data.type,
                                          record: record,
                                          "record-index": recordIndex,
                                          "record-count":
                                            _vm.data.records.length,
                                        },
                                        on: {
                                          "disable-show-row":
                                            _vm.disableRecordShow,
                                          "edit-worker": function ($event) {
                                            return _vm.$emit(
                                              "edit-worker",
                                              $event
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.data.type === "calculations"
                                    ? _c("c-table-actions", {
                                        attrs: {
                                          type: _vm.data.type,
                                          record: record,
                                          "record-index": recordIndex,
                                          "record-count":
                                            _vm.data.records.length,
                                        },
                                        on: {
                                          "disable-show-row":
                                            _vm.disableRecordShow,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                }),
              ],
              2
            ),
          ]),
        ]
      ),
      _vm.data.records.length === 0
        ? _c("div", { staticClass: "c-table__empty__records" }, [
            _vm._v(_vm._s(_vm.emptyRecordsLabel)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }